import React from "react";
import SvgIcon from "e100-react-components/lib/components/SvgIcon";
import { IProps } from "e100-react-components/lib/components/SvgIcon/index";

const Next = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M8 6.645L12.9447 12L8 17.355L9.52227 19L16 12L9.52227 5L8 6.645Z" />
  </SvgIcon>
);

export default Next;
